export const AUTHENTICATION_TYPE = 'AUTHENTICATION'

export const APP_LANGUAGE_SET = 'APP_LANGUAGE_SET'
export const APP_THEME_SET = 'APP_THEME_SET'
